import { createSelector } from "@reduxjs/toolkit";

export const agentsState = (state) => state.agents;

export const agentsSelector = createSelector(agentsState, (state) => state);
